export const WRAPPER_TEST_ID = 'wrapper';
export const CONFIG_CHANGE_BUTTON_TEST_ID = 'api-change-button';
export const CURRENT_API_TEST_ID = 'current-api';
export const API_INPUT_TEST_ID = 'api-input';
export const API_CHANGE_SUBMIT_TEST_ID = 'api-change-submit';
export const API_RESET_TEST_ID = 'api-reset';
export const API_URL_LS_KEY = 'api_url';
